export default __webpack_public_path__ + "assets/pdf/eLogbook_AirFrance_P2.d6bfc8bf.pdf";